import { LocalStorageService } from './../../core/services/local-storage.service';
import { environment } from './../../../environment/environment';
import { headerColumns9 } from './../../core/models/salarie';
import { Component, ElementRef, inject, TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { fileTypeExtention, serverError } from './../../core/models/messages';
import * as saveAs from 'file-saver';
import {
  linkedInRegExp,
  patternEmail,
  patternNumbersOnly,
  patternfirstName,
} from './../../core/models/pattern';
import { ProjetService } from './../../core/services/projet-service/projet.service';
import { SalarieService } from './../../core/services/salarie-service/salarie.service';
import { SortDataService } from './../../core/services/sortdata';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import {
  CountryISO,
  PhoneNumberFormat,
  SearchCountryField,
} from 'ngx-intl-tel-input';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { distinctUntilChanged, Subject, takeUntil } from 'rxjs';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SharedService } from '@shared/shared.service';

@Component({
  selector: 'app-employee',
  templateUrl: './employee.component.html',
  styleUrls: ['./employee.component.css'],
})
export class EmployeeComponent {
  isCollapsed = true;
  isLoadSpinner: boolean = true;

  toggleCollapsible() {
    this.isCollapsed = !this.isCollapsed;
  }
  fileErr: boolean = false;
  fileExtentions: string = '';
  selectedFile: File | null = null;
  fileBulkError: any;
  addBulk!: FormGroup;
  listsalaries: any = [];
  detailsalarie: any;
  listcompetences: any;
  idclientConnected: any;
  itemsPerPage: number = 5;
  currentPage: number = 1;
  listNames: string[] = [];
  currentSortDirection: number = 1;
  startIndex: number = 0;
  endIndex: number = 5;
  url: string = environment.baseUrl + '/api';
  urlimage: string = environment.baseUrlGalery;
  urlcv: string = environment.baseUrlGaleryCv;
  consultant_info: any;
  totalItems!: number;
  pagination : boolean =false;

  formsalaire: FormGroup = this.createForm();

  /* unsubscription */
  private unsubscribeAll: Subject<void> = new Subject();
  listskills: any;
  skillssalarie: any;
  skillssalariefinal: any = [];
  skills: any[] = [];
  projects: any[] = [];
  showResetButtons: boolean = true;
  file: any = '';
  idSalarie: any;
  fileExtention: string = '';
  fileError: string = '';
  fileName: string = '';
  submitted: boolean = false;
  skill: any = [];
  isexiste = false;
  dataHeader: any = [];
  candidat_id: any;
  PhoneNumberFormat = PhoneNumberFormat;
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  selectedCountryCode: string = 'FR';
  preferredCountries: CountryISO[] = [
    CountryISO.UnitedStates,
    CountryISO.UnitedKingdom,
  ];
  modalRef?: BsModalRef;
  consultantExterneExists: boolean = false;
  Existscandidat: boolean = false;
  Notexistcandidat: boolean = false;
  sortAttr = '';
  headerColumns: { checked: boolean; name: string; code: string }[] =
    headerColumns9;
  searchForm: FormGroup = this.createSearchForm();
  skillsList: { name_FR: string }[] = [];
  projetList: { name_PR: string }[] = [];
  listprojet: { id: number; name: string }[] = [];
  currentSortColumn: string = 'first_name';
  cv_file!: string;
  cv: any;
  id: any;
  data: any[] = [
    {
      competences: [
        'nom',
        'prenom',
        'num',
        'email',
        'email_pro',
        'poste',
        'mois_signature_contrat',
        'annee_signature_contrat',
        'salaire',
        'linkedin',
        'cv',
        'photo',
        'id_projet',
      ],
    },
  ];
  constructor(
    private formBuilder: FormBuilder,
    private modalService: BsModalService,
    private toastr: ToastrService,
    private salarieservice: SalarieService,
    private projetservice: ProjetService,
    private spinner: NgxSpinnerService,
    private toastrService: ToastrService,
    private sortDataService: SortDataService,
    private localStorageService: LocalStorageService,
    private route: Router,
    private dataService: SharedService,
    private elRef: ElementRef,

  ) {}
  ngOnInit() {
    this.getListsalarie();
    this.getListskills();
    this.getListprojet();
    this.getListElementHeader();
    this.formsalaire = this.formBuilder.group({
      clientFinal_id: ['', Validators.required],
      first_name: [
        '',
        [Validators.required, Validators.pattern(patternfirstName)],
      ],
      last_name: [
        '',
        [Validators.required, Validators.pattern(patternfirstName)],
      ],
      emailProClient: [
        '',
        [Validators.email, Validators.pattern(patternEmail)],
      ],
      email: [
        '',
        [
          Validators.required,
          Validators.email,
          Validators.pattern(patternEmail),
        ],
      ],
      linkedin_link: ['',Validators.pattern(linkedInRegExp)],
      poste: [''],
      salary: ['', [Validators.pattern(patternNumbersOnly)]],
      cv: [''],

      project_ids: [[]],
      candidate_id: [''],
      date_first_contract: [''],
    });
    this.formsalaire.get('linkedin_link')?.valueChanges
    .pipe(distinctUntilChanged())
    .subscribe(() => {
      this.setValidatorRequirements();
    });

  this.formsalaire.get('cv')?.valueChanges
    .pipe(distinctUntilChanged())
    .subscribe(() => {
      this.setValidatorRequirements();
    });
  this.setValidatorRequirements();
  const scrollableTable = this.elRef.nativeElement.querySelector('#kt_customers_table');
    scrollableTable?.addEventListener('scroll', this.closeDropdownOnScroll.bind(this));
  }
  closeDropdownOnScroll(): void {
    // Find the open dropdown
    const dropdown = this.elRef.nativeElement.querySelector('.dropdown-menu.show');
    
    // If the dropdown is open, remove the 'show' class to close it without triggering a page scroll
    if (dropdown) {
      dropdown.classList.remove('show');
      console.log('HEYYYYYYYYYYYY');
    }
  }
  /* key inter number */
  keyPress(event: any) {
    let pattern = /^[\d]$/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode !== 8 && pattern && !pattern.test(inputChar)) {
      event.preventDefault();
    }
    return pattern;
  }

  sortData(item: string) {
    console.log('item', item);
    for (const iterator of headerColumns9) {
      if (item == iterator.name) item = iterator.code;
    }
    this.sortAttr = item;
    this.currentSortDirection = this.currentSortDirection === 1 ? 2 : 1;
    this.currentPage = 1;
    this.endIndex = 5;
    if (this.searchForm.dirty)
      this.listsalaries = this.sortDataService.sortArray(
        this.listsalaries,
        item,
        this.currentSortDirection
      );
    else this.getListsalarie();
  }

  getItems(event?: any) {
    if (event) {
      this.startIndex = event.startIndex;
      this.endIndex = event.endIndex;
      (this.itemsPerPage = event.itemsPerPage),
        (this.currentPage = event.currentPage);
        if( (this.startIndex !=0 || this.endIndex !=5) || this.pagination == true){          this.pagination = true
           this.getListsalarie();
        }
    }
  }

  getListsalarie() {
    this.idclientConnected =
      this.localStorageService.getData('clientConnected');
    let dataPyload =
      this.sortAttr == ''
        ? {
            clientFinal_id: this.idclientConnected,
            per_page: this.itemsPerPage,
            page: this.currentPage,
          }
        : {
            ...{
              clientFinal_id: this.idclientConnected,
              per_page: this.itemsPerPage,
              page: this.currentPage,
            },
            ...{
              sort: this.currentSortDirection,
              sortAttribute: this.sortAttr,
            },
          };
    this.spinner.show();
    this.salarieservice.getListsalarie(dataPyload).subscribe({
      next: (response) => {
        this.isLoadSpinner = false;

        if (response.data && response.data.data) {
          this.listsalaries = response.data.data
          // .slice(0, this.endIndex);
          this.totalItems = response.data.total;
          this.spinner.hide();
        }
      },
      error: (error) => {
        this.spinner.hide();
        console.error('Error fetching salaries: ', error);
      },
    });
  }

  getListprojet() {
    this.idclientConnected =
      this.localStorageService.getData('clientConnected');

    this.projetservice.getprojets(this.idclientConnected).subscribe({
      next: (response) => {
        console.log('response projet', response);

        this.listprojet = response.data;
      },
      error: (error) => {
        console.error('Error fetching projet: ', error);
      },
    });
  }
  downloadCvV(salarie: any) {
    // const fileUrl = `${this.url}/User/file/gallery_cvs/`;
    let cv_file = this.urlcv + salarie.cv;
    console.log('cv_file', cv_file);
    const link = document.createElement('link');
    link.href = cv_file;
    // link.target = '_blank';
    console.log('salarie', salarie);
    // link.download = `${salarie.ID_user}_${salarie.first_name}_${salarie.last_name}_CV.${salarie!.cv.split('.').pop()}`
    link.click();
  }
  /* download file */
  downloadFile(salarie: any) {
    // if(!this.selectedCandidate.cv) {this.toastr.info(EmptyCV)}
    // else{
    this.spinner.show();
    const fileUrl = `${this.url}/User/file/gallery_cvs/${salarie.cv}`;
    this.salarieservice.downloadPDF(fileUrl).subscribe((blob) => {
      const fileURL = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = fileURL;
      a.download = `${salarie.ID_user}_${salarie.first_name}_${
        salarie.last_name
      }_CV.${salarie.cv.split('.').pop()}`;
      document.body.appendChild(a);
      a.click();
      this.spinner.hide();
    }
  );
    // }
  }

  resetCV() {
    const inputFile = document.getElementById('cv') as HTMLInputElement;
    if (inputFile) {
      inputFile.value = '';

      this.fileExtention = '';
      this.fileError = '';
    }
    this.fileName = '';
    this.showResetButtons = true;
  }
  // uploadFile(event: any) {
  //   this.file = event.target.files[0];
  //   const maxSize = 2 * 1024 * 1024;
  //   this.fileName = this.file.name;
  //   if (this.file) {
  //     const allowedExtensions = ['.pdf', '.docx', '.doc'];
  //     const fileExtension = this.file.name
  //       .toLowerCase()
  //       .substr(this.file.name.lastIndexOf('.'));
  //     if (!allowedExtensions.includes(fileExtension)) {
  //       this.fileExtention = 'Format fichier non compatible !';
  //     } else if (this.file.size > maxSize) {
  //       this.fileError = 'Le fichier à importer ne doit pas depasser 2 méga !';
  //     } else {
  //       this.fileError = '';
  //       this.fileExtention = '';
  //     }
  //   }
  //   // this.addCandidateFormGroup.markAsDirty();
  // }
  uploadFile(event: any) {
    this.file = event.target.files ? event.target.files[0] : null; // Vérifier si un fichier est sélectionné
    const maxSize = 2 * 1024 * 1024;

    if (this.file) {
        this.fileName = this.file.name;
        const allowedExtensions = ['.pdf', '.docx', '.doc'];
        const fileExtension = this.file.name
            .toLowerCase()
            .substr(this.file.name.lastIndexOf('.'));

        if (!allowedExtensions.includes(fileExtension)) {
            this.fileExtention = 'Format fichier non compatible !';
        } else if (this.file.size > maxSize) {
            this.fileError = 'Le fichier à importer ne doit pas depasser 2 méga !';
        } else {
            this.fileError = '';
            this.fileExtention = '';
        }
    } else {
        // Si aucun fichier n'est sélectionné
        this.fileError = '';
        this.fileExtention = '';
        this.fileName = '';
        this.formsalaire.get('cv')?.setValue(null); // Réinitialiser la valeur du champ cv
    }
    this.formsalaire.get('cv')?.setValue(this.file);
}

  isFileNameCompatible(): boolean {
    if (!this.file) {
      return false; // Aucun fichier sélectionné
    }

    const allowedExtensions = ['.pdf', '.docx', '.doc'];
    const fileExtension = this.file.name
      .toLowerCase()
      .substr(this.file.name.lastIndexOf('.'));
    return allowedExtensions.includes(fileExtension);
  }

  createsalarie() {
   
      this.formsalaire.markAllAsTouched();
      this.formsalaire.markAsDirty();

    if (!this.isexiste) {
      this.setValidatorRequirements();

      this.idclientConnected =
        this.localStorageService.getData('clientConnected');
      this.formsalaire.patchValue({
        clientFinal_id: this.idclientConnected,
      });

      console.log('formsalarie', this.formsalaire.value);

      let fromdata = new FormData();
      fromdata.append('clientFinal_id', this.formsalaire.value.clientFinal_id);
      fromdata.append('first_name', this.formsalaire.value.first_name);
      fromdata.append('last_name', this.formsalaire.value.last_name);
      if (this.formsalaire.value.emailProClient) {
        fromdata.append(
          'emailProClient',
          this.formsalaire.value.emailProClient
        );
      } else {
        fromdata.append('emailProClient', '');
      }
      if (this.formsalaire.value.email) {
        fromdata.append('email', this.formsalaire.value.email);
      } else {
        fromdata.append('email', '');
      }
      fromdata.append(
        'date_first_contract',
        this.formsalaire.value.date_first_contract
      );

      if (this.formsalaire.value.poste) {
        fromdata.append('poste', this.formsalaire.value.poste);
      } else {
        fromdata.append('poste', '');
      }
      if (this.formsalaire.value.salary) {
        fromdata.append('salary', this.formsalaire.value.salary);
      } else {
        fromdata.append('salary', '');
      }
      if (this.formsalaire.value.linkedin_link) {
        fromdata.append('linkedin_link', this.formsalaire.value.linkedin_link);
      } else {
        fromdata.append('linkedin_link', '');
      }
      if (
        this.formsalaire.value &&
        Array.isArray(this.formsalaire.value.project_ids)
      ) {
        const project_ids = this.formsalaire.value.project_ids;
        for (const projectId of project_ids) {
          fromdata.append('project_ids[]', projectId);
        }
      } else {
        console.error("project_ids n'est pas un tableau ou n'est pas défini.");
      }

      if (this.file) fromdata.append('cv', this.file);

      this.enableFormFields();

      this.salarieservice.createsalarie(fromdata).subscribe({
        next: (response) => {
          console.log('add salaries', response);
          this.toastrService.success('Le salarié a été ajouté avec succès. ');
          this.close_modal_add();
          this.getListsalarie();
        },
        error: (error: any) => {
          console.error('Error fetching add salaries: ', error);

          if (error?.error && error?.error?.message) {
            if (
              error?.error.message.linkedin_link &&
              error?.error.message.linkedin_link[0] && error?.error.message.linkedin_link[1] ==='The linkedin_link has already been taken.') {
              this.toastr.error('Linkedin a déjà été utilisé.');
              // this.close_modal_add();
            }
            if (
              error?.error.message.emailProClient &&
              error?.error.message.emailProClient[0] ==='The email pro client has already been taken.'
            ) {
              this.toastr.error(
                "L'adresse e-mail professionel a déjà été utilisée."
              );
              // this.close_modal_add();
            }
            if (
              error?.error.message.email[0] ==='The email has already been taken.'
            ) {
              this.toastr.error(
                "L'adresse e-mail a déjà été utilisée."
              );
              // this.close_modal_add();
            }
          }
        },
      });
    } else {
      this.idclientConnected =
        this.localStorageService.getData('clientConnected');
      let data = {
        clientFinal_id: this.idclientConnected,
        candidate_id: this.candidat_id,
        salary: this.formsalaire.value.salary,
        poste: this.formsalaire.value.poste,
        emailProClient: this.formsalaire.value.emailProClient,
        project_ids: this.formsalaire.value.project_ids,
      
      };

      this.salarieservice.createsalarie(data).subscribe({
        next: (response) => {
          console.log('add salaries', response);
          this.toastrService.success('Le salarié a été ajouté avec succès. ');
          this.close_modal_add();
          this.getListsalarie();
        },
        error: (error) => {
          console.error('Error fetching add salaries: ', error);
          console.log('msg email', error?.error['message']);
          if (
            error?.error['message'] === 'salarie already associated to another Client.'
          ) {
            this.toastr.error('salarié Déjà Associé !');
            //this.close_modal_add();
          }
          
          if (
            error?.error.message.linkedin_link &&
            error?.error.message.linkedin_link[0] && error?.error.message.linkedin_link[1] ===
              'The linkedin link has already been taken.'
          ) {
            this.toastr.error('The linkedin link a déjà été utilisé.');
            //this.close_modal_add();
          }
          if (
            error?.error.message.emailProClient &&
            error?.error.message.emailProClient[0] ===
              'The email pro client has already been taken.'
          ) {
            this.toastr.error(
              "L'adresse e-mail professionel a déjà été utilisée."
            );
            //this.close_modal_add();
          }
        },
      });
    }
  }

 

  setValidatorRequirements() {
    const linkedinControl = this.formsalaire.get('linkedin_link');
    const cvControl = this.formsalaire.get('cv');

    linkedinControl?.clearValidators();
    cvControl?.clearValidators();

    if (!linkedinControl?.value && !cvControl?.value) {
        linkedinControl?.setValidators([
           
            Validators.pattern(linkedInRegExp),
        ]);
        cvControl?.setValidators(Validators.required);
    } else {
        if (linkedinControl?.value) {
            linkedinControl?.setValidators([Validators.pattern(linkedInRegExp)]);
        }
        if (cvControl?.value) {
            cvControl?.clearValidators();
        }
    }

    linkedinControl?.updateValueAndValidity({ emitEvent: false });
    cvControl?.updateValueAndValidity({ emitEvent: false });
}

  
  currentEmail: string = '';
  iscv:boolean=false
  getsalarieByEmail(event: any) {
    console.log('event', event.target.value);
    if (event.target.value === '') {
      this.enableFormFields();
      this.formsalaire.patchValue({
        first_name: '',
        last_name: '',
        linkedin_link: '',
        cvName: '',
        desired_workstation: '',
      });
      this.isexiste = false;
      return;
    }
  
    this.salarieservice
      .getsalariebyemail(event.target.value, this.idclientConnected)
      .subscribe({
        next: (res) => {
          if (res.status === 200) {
            console.log('reponse', res);
            this.isexiste = true;
            if(res.data.cv && res.data.cv!=='null'){
              this.iscv=true
             }
             else{
              this.iscv=false
             }
            this.cv = res.data.cv;
            this.candidat_id = res.data.id;
            this.disableFormFields();
            this.formsalaire.patchValue({
              first_name: res.data.first_name,
              last_name: res.data.last_name,
              emailProClient: res.data.emailProClient,
              linkedin_link: res.data.linkedin_link,
              cv: res.data.cv,
            });
  
            // Save current email to check for changes later
            this.currentEmail = event.target.value;
  
            // Force validation of form fields
            this.formsalaire.get('email')!.updateValueAndValidity();
            this.formsalaire.get('linkedin_link')!.updateValueAndValidity();
  
            if (this.currentEmail !== res.data.email) {
              this.formsalaire.patchValue({
                first_name: '',
                last_name: '',
                selectedconsultant: '',
                desired_workstation: '',
                linkedin_link: '',
              });
              this.isexiste = false;
       
            }
  
            if (res.data.cv) {
              this.file = { name: res.data.cv };
              console.log('file', this.file.name);
            }
  
            if (res.data.linkedin_link != null || res.data.linkedin_link != '') {
              this.formsalaire.get('linkedin_link')?.disable();
            }
            this.disableFormFields();
          }
          else{
            this.formsalaire.patchValue({
              first_name: '',
              last_name: '',
              selectedconsultant: '',
              desired_workstation: '',
              linkedin_link: '',
            });
            this.isexiste = false;
            this.Existscandidat = false;
            this.consultantExterneExists = false;

          }
        },
        error: (error: any) => {
          this.isexiste = false;
          this.iscv=false
          this.cv = '';
          this.enableFormFields();
          this.formsalaire.get('linkedin_link')?.enable();
          console.log('error', error);
          console.log('msg email', error?.error.message);
          if(error?.error.status == 400 &&  error?.error.message === 'this canddiat was already a salary with this client'){
            this.toastr.error("ce canddiat était déjà un salaire avec ce client");

          }
          if (error?.error && error?.error?.message === 'this candidat was already a consultant externe fot this company') {
            this.consultantExterneExists = true;
          } else {
            this.consultantExterneExists = false;
          }
          if (error?.error && error?.error?.message === 'this canddiat was already a consultant') {
            this.Existscandidat = true;
            console.log('existe', this.Existscandidat);
          } else {
            this.Existscandidat = false;
            console.log('existe', this.Existscandidat);
          }
          if (error?.error && error?.error?.message === 'User profile was not completed') {
            this.Notexistcandidat = true;
            console.log('existe', this.Notexistcandidat);
          } else {
            this.Notexistcandidat = false;
            console.log('existe', this.Notexistcandidat);
          }
        },
      });
      console.log("iscv",this.iscv)
  }

  disableFormFields() {
    if (this.formsalaire) {
      this.formsalaire.get('first_name')?.disable();
      this.formsalaire.get('last_name')?.disable();
      this.formsalaire.get('personal_email')?.disable();
      this.formsalaire.get('phone_number')?.disable();
      this.formsalaire.get('years_of_experience')?.disable();
      this.formsalaire.get('linkedin_link')?.disable();
    }
  }
  enableFormFields() {
    if (this.formsalaire) {
      this.formsalaire.get('first_name')?.enable();
      this.formsalaire.get('last_name')?.enable();
      this.formsalaire.get('personal_email')?.enable();
      this.formsalaire.get('phone_number')?.enable();
      this.formsalaire.get('years_of_experience')?.enable();
      this.formsalaire.get('skills')?.enable();
      this.formsalaire.get('cv')?.enable();
      this.formsalaire.get('linkedin_link')?.enable();
    }
  }

  resetform() {
    this.formsalaire.reset();
    this.submitted = false;
    this.cv = '';
    this.consultantExterneExists = false;
  }

  close_modal_add() {
    let btnClose = document.getElementById('ModalClose_add_salarie');
    this.formsalaire.reset();
    console.log('btnClose', btnClose);
    if (btnClose) {
      btnClose.click();
    }
    this.modalRef?.hide();
    this.submitted = false;
    this.iscv=false
    this.cv = '';
    this.showResetButtons = false;
  }

  getListskills() {
    this.salarieservice.getSkills().subscribe({
      next: (response) => {
        console.log('list skills', response);
        if (response.data) {
          this.skillsList = response.data;
          this.listskills = response.data;
          this.skills = response.data;
          console.log('list skills', this.listskills);
        }
      },
      error: (error) => {
        console.error('Error fetching skills: ', error);
      },
    });
  }

  /* get phone number */
  changePhoneNumber(event: any) {
    if (event.phoneNumber)
      this.formsalaire.get('phone_number')?.setValue(event.phoneNumber);
  }

  // get salarie detail
  getsalarieById(id: any) {
    console.log('id salarie', id);
    this.idSalarie = id;
    this.idclientConnected =
      this.localStorageService.getData('clientConnected');
    this.salarieservice.getsalarieById(this.idclientConnected, id).subscribe({
      next: (res: any) => {
        this.detailsalarie = res.data[0];
      },
      error: (error) => {
        console.error('Error detail salarie: ', error);
      },
    });
    this.getSkills();
  }
  // getskills salarie
  getSkills() {
    this.salarieservice.getskillssalarie(this.idSalarie).subscribe({
      next: (res) => {
        console.log('list skills salarie', res);
        this.skillssalariefinal = [];
        this.skillssalarie = res.data.categoriesWithSubCategoriesAndSkills;
        if (this.skillssalarie.length != 0) {
          for (let i = 0; i < this.skillssalarie.length; i++) {
            this.skillssalariefinal.push(this.skillssalarie[i].sub_category);
          }
          console.log('list skills final', this.skillssalariefinal);
        } else {
          console.log('aucune compétence');
        }
      },
      error: (error) => {
        console.error('Error skills salarie: ', error);
      },
    });
  }
  onSalaryRangeInput(event: any) {
    const value = event.target.value;
    if (value.toLowerCase().endsWith('k')) {
      this.searchForm.controls['salary_range'].setValue(
        this.convertKToNumber(value)
      );
    }
  }

  convertKToNumber(value: any) {
    if (typeof value === 'string' && value.toLowerCase().endsWith('k')) {
      return parseFloat(value.slice(0, -1)) * 1000;
    } else if (!isNaN(value)) {
      return parseFloat(value) * 1000;
    }
    return parseFloat(value);
  }
  createSearchForm(data?: any) {
    return this.formBuilder.group({
      name: ['', data?.name],
      poste: ['', data?.poste],
      project_id: ['', data?.project_id],
      skillsOr: [[], data?.skillsOr],
      skillsAnd: [[], data?.skillsAnd],
      max_experience_years: ['', data?.max_experience_years],
      min_experience_years: ['', data?.min_experience_years],
      salary: ['', data?.salary],
      salary_range: ['', data?.salary_range],
      search: [
        '',
        [Validators.pattern(/^("([^"]*"(AND|NOT|,|&&)[^"]*)*"|[^\s"']+)$/)],
      ],
      per_page: this.itemsPerPage,
      page: this.currentPage,
    });
  }

  /* search */
  searchSalarie() {
    this.idclientConnected =
      this.localStorageService.getData('clientConnected');
    let valueForm = this.searchForm.value;
    this.searchForm.value.salary_range = this.convertKToNumber(
      this.searchForm.value.salary_range.toString()
    );

    let data = {
      clientFinal_id: this.idclientConnected,
      per_page: this.itemsPerPage,
      page: this.currentPage,
      name: this.searchForm.value.name,
      skillsOr: this.searchForm.value.skillsOr,
      skillsAnd: this.searchForm.value.skillsAnd,
      poste: this.searchForm.value.poste,
      salary: this.searchForm.value.salary,
      salary_range: this.searchForm.value.salary_range,
      max_experience_years: this.searchForm.value.max_experience_years,
      min_experience_years: this.searchForm.value.min_experience_years,
      project_id: this.searchForm.value.project_id
        ? this.searchForm.value.project_id.toString()
        : '',
      search: this.transformSearch(valueForm?.search),
    };
    console.log('data', data);
    this.spinner.show();
    this.salarieservice.searchsalarie(data).subscribe({
      next: (resSearch) => {
        if ( this.currentPage > 1) {
          this.currentPage = 1;
          this.searchSalarie();
          this.spinner.hide();
          console.log('response search', resSearch);
        } else {
          this.listsalaries = resSearch.data.data.slice(0, this.endIndex);
          this.totalItems = resSearch.data.total;
          this.spinner.hide();
        }
      },
      error: (error) => {
        console.log(error);
        this.toastr.error(serverError);
        this.spinner.hide();
      },
    });
  }
  transformSearch(search: string): string {
    // Remplace toutes les occurrences de '||' par 'OR'
    search = search.replace(/\|\|/g, ' OR ');

    // Remplace toutes les occurrences de '&&' par ' AND '
    search = search.replace(/&&/g, ' AND ');

    // Remplace toutes les occurrences de '!' par ' NOT '
    search = search.replace(/!/g, ' NOT ');

    // Ajoute des espaces autour des opérations logiques pour éviter des conflits avec les mots
    search = search.replace(/\b(AND|OR|NOT)\b/g, ' $1 ');

    // Remplace les termes entre guillemets doubles par les mêmes termes sans modification
    // et échappe les guillemets simples à l'intérieur des termes non compris entre guillemets
    search = search.replace(/"([^"]+)"|(\S+)/g, (match, p1, p2) => {
      if (p1) {
        return `"${p1}"`;
      } else {
        // Si le terme n'est pas entre guillemets, échappe les guillemets simples à l'intérieur du terme
        const escapedTerm = p2.replace(/"/g, '\\"');
        return `${escapedTerm}`;
      }
    });

    // Supprime les espaces en double pour une meilleure lisibilité
    search = search.replace(/\s+/g, ' ');

    // Renvoie la chaîne de recherche transformée
    return search.trim();
  }

  concatenateSkills(): string {
    const allSkills = this.skillssalariefinal
      .flatMap((subSkillList: any) =>
        subSkillList.map((sub: any) => sub.name_FR)
      )
      .join(', ');

    return allSkills;
  }

  redirectToLinkedIn(linkedinLink: string): void {
    window.open(linkedinLink, '_blank');
  }
  redirectToDetail(data:any): void {
    this.dataService.setData(data);

    // this.route.navigateByUrl(
    //   '/detailemployee/'+ data.id
    // );  
    this.route.navigateByUrl('/detailemployee', { state: { id : data.id ,data: data } });

  }
  reset() {
    this.searchForm.reset();
    this.searchForm = this.createSearchForm();
    this.searchSalarie();
  }

  createForm(data?: any) {
    return this.formBuilder.group(
      {
        first_name: [data ? data?.first_name : '', [Validators.required]],
        last_name: [data ? data?.last_name : '', [Validators.required]],
        emailProClient: [
          data ? data?.emailProClient : '',
          [Validators.pattern(patternEmail)],
        ],
        email: [
          data ? data?.email : '',
          [
            Validators.required,
            Validators.email,
            Validators.pattern(patternEmail),
          ],
        ],
        linkedin_link: [data ? data?.linkedin_link : '',[Validators.pattern(linkedInRegExp)]],
        project_ids: [data ? data?.project_ids : []],
        poste: [data ? data?.poste : ''],
        cv: [data && data.cv ? data.cv : ''],
        date_first_contract: [data ? data?.date_first_contract : ''],
        salary: [
          data ? data?.salary : '',
          [Validators.pattern(patternNumbersOnly)],
        ],
        consultant_client_final_id: [
          data ? data?.consultant_client_final_id : '',
        ],
        user_id: [data ? data?.user_id : ''],
        clientFinal_id: [data ? data?.clientFinal_id : ''],
      },
      {}
    );
  }
  openModaladd(template: TemplateRef<any>)
  {
    this.modalRef = this.modalService.show(template, { backdrop: 'static' });
    this.consultantExterneExists = false;
    this.isexiste=false;
    this.enableFormFields();
  }
  openModal(template: TemplateRef<any>, data?: any, mode?: string) {
    this.modalRef = this.modalService.show(template, { backdrop: 'static' });
    this.id = data.id;
    console.log('data', data);
    this.formsalaire = this.createForm(data);
    console.log('updatte---', this.formsalaire.value);

    const projectNames = data.project_names || [];
    const selectedProjectIDs = this.listprojet
      .filter((project) => projectNames.includes(project.name))
      .map((project) => project.id);
    this.formsalaire.get('project_ids')?.setValue(selectedProjectIDs);
    this.formsalaire.get('user_id')?.setValue(data?.id);
    this.formsalaire
      .get('consultnat_client_final_id')
      ?.setValue(data.consultant_client_final_id);
    this.formsalaire
      .get('date_first_contract')
      ?.setValue(data.salary_date_first_contract);
      console.log('updatte---', this.formsalaire.value);

  }

  updatesalarier() {
    this.idclientConnected =
      this.localStorageService.getData('clientConnected');
    this.formsalaire.get('clientFinal_id')?.setValue(this.idclientConnected);
    this.formsalaire.get('user_id')?.setValue(this.id);
    console.log('log', this.formsalaire.value);
    this.salarieservice.updatesalarier(this.formsalaire.value).subscribe({
      next: (response) => {
        this.toastrService.success('Salarié a été modifié avec succès');
        this.close_modal_add();
        this.getListsalarie();
      },
      error: (error) => {
        console.error('Error updating fournisseur: ', error);
        if (
          error?.error['message'] === 'salarie already associated to Client.'
        ) {
          this.toastr.error('salarié  Déjà Associé !');
          this.close_modal_add();
        }
        if (
          error?.error.message.linkedin_link &&
          error?.error.message.linkedin_link[0] ===
            'The linkedin link has already been taken.'
        ) {
          this.toastr.error("L'linkedin a déjà été utilisé.");
          this.close_modal_add();
        }
        if (
          error?.error.message.emailProClient &&
          error?.error.message.emailProClient[0] ===
            'The email pro client has already been taken.'
        ) {
          this.toastr.error(
            "L'adresse e-mail professionel a déjà été utilisée."
          );
          this.close_modal_add();
        }
      },
    });
  }

  /*download file add bulk */
  downloadCsv() {
    this.salarieservice.downloadcsvfileAddBulksalarie().subscribe({
      next: (res: Blob) => {
        console.log("res", res);
        const blob = new Blob([res], { type: 'text/csv;charset=utf-8;' });
        saveAs(blob, 'ajout en masse client salarie.csv');
      },
      error: (err) => {
        console.log('error', err);
        // Handle the error appropriately
      },
    });
  }

  openModalBulk(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { backdrop: 'static' });
    this.formsalaire.get('open_for_mission')?.setValue(1);
    this.fileExtentions = '';
  }

  formAddBulk() {
    this.addBulk = this.formBuilder.group({
      file: [null, [Validators.required]],
    });
  }
  /*select file and add Bulk Candidates */
  onFileSelected(event: any) {
    this.fileErr = false;
    this.fileExtentions = '';
    this.selectedFile = event.target.files[0];

    if (this.selectedFile) {
      console.log('Fichier sélectionné :', this.selectedFile);
      const fileExtension = this.selectedFile.name
        .toLowerCase()
        .substr(this.selectedFile.name.lastIndexOf('.'));
      const allowedExtensions = ['.csv', '.xlsx', '.xls'];
      if (!allowedExtensions.includes(fileExtension)) {
        console.log('selectedFile', fileExtension);
        this.fileExtentions = fileTypeExtention;
        this.fileErr = true;
      }
    }
  }

  addBulkCandidates() {
    if (this.selectedFile) {
      const formData = new FormData();
      formData.append('file', this.selectedFile);
      formData.append('client_id', this.idclientConnected);
      console.log('formdata', formData);
      this.spinner.show();
      this.salarieservice.addBulkCandidates(formData).subscribe({
        next: (res: any) => {
          this.spinner.hide();

          this.fileBulkError = res.export_file;
          console.log('file bluk error', this.fileBulkError);
          this.getbulkCandidate(this.fileBulkError);
          this.toastr.success('Fichier importé avec succès');
          this.closeModal();
          this.selectedFile = null;
        },
        error: (err) => {
          console.log('error', err);
          this.spinner.hide();
          if (err?.error) {
            if (err.error?.message) {
              if (err.error.message === 'File contains only headers.') {
                this.toastr.error('Le fichier est vide');
              } else if (
                err.error.message ===
                'File headers do not match the expected headers.'
              ) {
                this.toastr.error(
                  'Les en-têtes de fichiers ne correspondent pas aux en-têtes attendus.'
                );
              } else {
                this.toastr.error(serverError);
              }
            } else {
              this.toastr.error(serverError);
            }
            this.closeModal();
            this.selectedFile = null;
          }
        },
      });
    }
  }
  getbulkCandidate(file: File) {
    let exportSuccess = false;
    this.salarieservice.getbulkCandidate(file).subscribe({
      next: (res: any) => {
        this.spinner.hide();
        const blob = new Blob([res], { type: 'application/octet-stream' });
        saveAs(blob, this.fileBulkError);
        exportSuccess = true;
        if (exportSuccess) {
          this.toastr.success(
            'Résultat de fichier importé a été exporté avec succès'
          );
        }
      },
      error: (err) => {
        console.log('error', err);
        this.spinner.hide();
        this.toastr.error(serverError);
      },
    });
  }
  closeModal() {
    this.formsalaire.reset();
    this.modalRef!.hide();
  }
  /*page consultant externel */
  getListElementHeader() {
    // if(!this.typeintervenant){
    this.salarieservice
      .getHeaderElementssalariecf(22)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.dataHeader = res.data;
          for (const iterator of this.dataHeader) {
            if (
              (iterator.checked == 'oui' && !iterator.checked_user) ||
              (iterator.checked == 'non' && iterator.checked_user == 'oui') ||
              (iterator.checked == 'oui' && iterator.checked_user == 'oui')
            )
              this.listNames.push(iterator.name);
          }
          this.dataHeader.map((el: any) => {
            if (
              (el.checked == 'oui' && !el.checked_user) ||
              (el.checked_user == 'oui' &&
                (el.checked == 'non' || el.checked == 'oui'))
            ) {
              return (el.checkAdmin = true);
            } else {
              return (el.checkAdmin = false);
            }
          });
        },
        error: () => {},
      });
    // }
    // else{
    //   this.esnconsultantservice
    //   .listPageconsultantActorIntervenant()
    //   .pipe(takeUntil(this.unsubscribeAll))
    //   .subscribe({
    //     next: (res) => {
    //       this.dataHeader = res.data;
    //       for (const iterator of this.dataHeader) {
    //         if (
    //           (iterator.checked == 'oui' && !iterator.checked_user) ||
    //           (iterator.checked == 'non' && iterator.checked_user == 'oui') ||
    //           (iterator.checked == 'oui' && iterator.checked_user == 'oui')
    //         )
    //           this.listNames.push(iterator.name);
    //       }
    //       this.dataHeader.map((el: any) => {
    //         if (
    //           (el.checked == 'oui' && !el.checked_user) ||
    //           (el.checked_user == 'oui' &&
    //             (el.checked == 'non' || el.checked == 'oui'))
    //         ) {
    //           return (el.checkAdmin = true);
    //         } else {
    //           return (el.checkAdmin = false);
    //         }
    //       });
    //     },
    //     error: () => {},
    //   });
    // }
  }

  changeSelectionElement(event: any, data: any, i: number) {
    this.listNames = [];
    data.checkAdmin = event.target.checked;
    for (const iterator of this.dataHeader) {
      if (iterator.checkAdmin) this.listNames.push(iterator.name);
    }
    this.changeSelectionHeadrElements(data);
  }
  changeSelectionHeadrElements(data: any) {
    // if(!this.typeintervenant){
    let payload = {
      sub_page_id: data?.id,
    };
    this.salarieservice
      .changeDelectedElementHeadesalariecf(payload)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {},
        error: () => {},
      });
    // }
    // else{
    //   let payload={
    //     sub_page_id:data?.id
    //   }
    //   this.esnconsultantservice.changeSubPageStateconsultantIntervenant(payload).pipe(takeUntil(this.unsubscribeAll)).subscribe({
    //     next: (res) => {

    //     },
    //     error: () => {

    //     }
    //   })
    // }
  }
}
